/**
 * MessageLogic - Service functions for Message POJO operations
 */

import type { Message } from './types';

export const MessageLogic = {
  /**
   * Create a Message POJO with the given body.
   */
  create(body: string): Message {
    return { body };
  },

  /**
   * Returns the full message as a string.
   */
  toString(message: Message): string {
    return message.body;
  },
};
